import { FiHome } from '@react-icons/all-files/fi/FiHome'

// navigate to home screen, customer's home address

export const IconHome = FiHome
